import { render, staticRenderFns } from "./AthleteSelfAssessmentFormStep.vue?vue&type=template&id=380be08e&scoped=true&"
import script from "./AthleteSelfAssessmentFormStep.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentFormStep.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentFormStep.vue?vue&type=style&index=0&id=380be08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380be08e",
  null
  
)

export default component.exports